module.exports = __webpack_public_path__ + "img/arrow_forward_ios_black_24dp.7a7fbe3f.svg";